import { LAMPORTS_PER_SOL } from '@solana/web3.js';

export function calculateRequiredMicroLamportsFromTxCost(solCost: number, computeUnitLimit: number): bigint {
    const solCostInLamports = BigInt(solCost * LAMPORTS_PER_SOL);
    return (solCostInLamports * 1000000n) / BigInt(computeUnitLimit);
}
